import React, { Component } from 'react';
import styled from 'styled-components';
import media from './MediaQueries';

import uv from '../../images/instore/icons/uv.svg';
import humidity from '../../images/instore/icons/humidity.svg';
import pollution from '../../images/instore/icons/pollution.svg';

const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 75px;

  ${media.phone`
    height: 60px;
  `}

  h3.weatherItemValue, h4.weatherItemLabel {
    font-size: 14px;
    font-weight: 400;
    color: white;

    ${media.phone`
      font-size: 12px;
      font-weight: 700;
    `}

  }
  h4.weatherItemLabel {
    text-transform: capitalize;
  }
  .icon {
    width: 24px;
    height: 24px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100%;

    ${media.phone`
      width: 16px;
      height: 16px;
    `}

  }
  .uv {
    background-image: url(${uv});
  }
  .humidity {
    background-image: url(${humidity});
  }
  .pollution {
    background-image: url(${pollution});
  }
`

const WeatherItemIcons = {
  uv: 'uv',
  humidity: 'humidity',
  pollution: 'pollution'
};

class WeatherItem extends Component {
  render = () => {
    return (
      <StyledItem>
        <h3 className="weatherItemValue">{this.props.value}</h3>
        <div className={'icon '+this.props.icon}></div>
        <h4 className="weatherItemLabel">{this.props.label}</h4>
      </StyledItem>
    )
  }
}

export {
  WeatherItem,
  WeatherItemIcons
}

export default WeatherItem;


// WEBPACK FOOTER //
// ./src/components/instore/WeatherItem.js